<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <b-link class="brand-logo">
     
      <h2 class="brand-text text-primary ml-1">
        Thiql Meeting
      </h2>
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
      لم يتم العثور على الصفحة 🕵🏻‍♀️
        </h2>
        <p class="mb-2">
          Oops! 😖 لم يتم العثور على عنوان URL المطلوب على هذا الخادم.
        </p>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          href="https://smart-consultation.test/"
          target="_blank"
        >
        العودة إلى الصفحة الرئيسية
        </b-button>

        <!-- image -->
        <b-img
          fluid
          src="/error.svg"
          alt="Error page"
        />
      </div>
    </div>
  </div>
<!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import { BLink, BButton, BImg } from 'bootstrap-vue' 
 

export default {
  components: {
    
    BLink,
    BButton,
    BImg,
  },
  data() {
    return {
      downImg: '',
    }
  },
  computed: {
   
  },
}
</script>

<style  scoped>

  .misc-wrapper {
  display: flex;
  flex-basis: 100%;
  min-height: 100vh;
  width: 100%;
  align-items: center;
  justify-content: center;
}
.misc-wrapper .misc-inner {
  position: relative;
  max-width: 750px;
}
.misc-wrapper .brand-logo {
  display: flex;
  justify-content: center;
  position: absolute;
  top: 2rem;
}
.misc-wrapper .brand-logo {
  margin: 0;
}
/*.misc-wrapper .brand-logo {
  left: 2rem;
}*/
.misc-wrapper .brand-logo {
  right: 2rem;
}
.misc-wrapper .brand-logo .brand-text {
  font-weight: 600;
}
@media (max-height: 625px) {
.misc-wrapper .misc-inner {
    margin-top: 4rem;
}
}
.brand-logo svg {
  width: 200px !important;
  height: 100px !important;
}
img {
    border-style: none;
}
.img-fluid {
    max-width: 100%;
      height: 299px;
    width: 100%;
}
.text-center {
    text-align: center !important;
}
.mb-1,.my-1 {
    margin-bottom: 1rem !important;
}
.w-100 {
    width: 100% !important;
}
img {
    vertical-align: middle;
}
.btn-primary {
    color: #fff !important;
}
.btn {
    text-align: center;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 0.786rem 1.5rem;
    border-radius: 0.358rem;
    -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, background 0s, border 0s, -webkit-box-shadow 0.15s ease-in-out;
}

.btn:not(:disabled):not(.disabled) {
    cursor: pointer;
}
.btn-primary {
    border-color: #2f4080 !important;
    background-color: #2f4080 !important;
}
.btn {
    -webkit-box-shadow: none;
    box-shadow: none;
}
.mb-2, .my-2 {
    margin-bottom: 1.5rem !important;
}
.p-2 {
    padding: 1.5rem !important;
}
@media (min-width: 576px){
 .p-sm-3 {
    padding: 3rem !important;
}
}


</style>